module.exports = __webpack_public_path__ + "img/co-branding-logo-KFC.1d092559.png";